var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant === 'drawer')?_c('img',{staticClass:"app-logo app-logo--drawer",attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('v-img',{staticClass:"app-logo app-logo--login my-12",attrs:{"src":_vm.src,"alt":_vm.alt,"contain":"","aspect-ratio":_vm.aspectRatio}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d35f0160","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"objectAssign":"Object.assign","transforms":{"stripWith":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLogo.vue
// module id = null
// module chunks = 